// Call this mixin in any
/**
 * This mixins hold two funcation alities, If you want call log rocket on any mounted or created call,
 * You just need to register the name of component in 'componentName' variable. If that not case & you want to call
 * log rocket you just need to add mixin in component & call initateLogRocket funcation
 */
import LogRocket from "logrocket";

export default {
  methods: {
    initateLogRocket() {
      const domainName = window.location.hostname;
      const account =
        domainName == "wpo-admin.bigscoots.com"
          ? "avvfqv/bigscoots"
          : "kolzqv/septemsystem";
      let userDtls = JSON.parse(localStorage.getItem("userDtls"));
      LogRocket.init(account, {
        console: {
          isEnabled: {
            log: true,
            info: true,
            debug: true,
            warn: true,
            error: true,
          },
        },
      });
      let uid = typeof userDtls.uid ? userDtls.uid : "User Logs";
      let name = typeof userDtls.firstName ? userDtls.firstName : "User Logs";
      let email = typeof userDtls.email ? userDtls.email : "User Logs";
      LogRocket.identify(uid, {
        name: name,
        email: email,
      });
      // Getting Log Rocket session
      LogRocket.getSessionURL((sessionURL) => {
        console.log("Log Rocket Session url: ", sessionURL);
      });
    },
  },
  created() {
    // This variable has name of the componenets in which initate log rocket will auto call
    const componentName = ["migrationTasks"];
    if (componentName.includes(this.$options.name)) this.initateLogRocket();
  },
};
